import { IconWrapper } from 'components/Identicon/StatusIcon'
import { darken } from 'polished'
import { AlertTriangle } from 'react-feather'
import styled from 'styled-components/macro'
import { flexRowNoWrap } from 'theme/styles'

import { ButtonSecondary } from '../Button'

const FULL_BORDER_RADIUS = 9999

const Web3StatusGeneric = styled(ButtonSecondary)`
  ${flexRowNoWrap};
  width: 100%;
  align-items: center;
  padding: 0.5rem;
  border-radius: ${FULL_BORDER_RADIUS}px;
  cursor: pointer;
  user-select: none;
  height: 36px;
  margin-right: 2px;
  margin-left: 2px;
  &:focus {
    outline: none;
  }
`
export const Web3StatusError = styled(Web3StatusGeneric)`
  background-color: ${({ theme }) => theme.accentFailure};
  border: 1px solid ${({ theme }) => theme.accentFailure};
  color: ${({ theme }) => theme.white};
  font-weight: 500;
  &:hover,
  &:focus {
    background-color: ${({ theme }) => darken(0.1, theme.accentFailure)};
  }
`
export const Web3StatusConnectWrapper = styled.div<{ faded?: boolean }>`
  ${flexRowNoWrap};
  height: 40px;
  padding: 0;
  align-items: center;
  border-radius: 16px;
  background: rgba(97, 105, 113, 0.08);
  color: ${({ theme }) => theme.navbarBtnColor};
  border: 2px solid ${({ theme }) => theme.navbarBtnBorder};
  transition: ${({
    theme: {
      transition: { duration, timing },
    },
  }) => `${duration.fast} color ${timing.in}`};
  &:hover,
  &:focus {
    border: 2px solid ${({ theme }) => darken(0.05, theme.deprecated_bg3)};
  }
`
export const Web3StatusConnected = styled(Web3StatusGeneric)<{
  pending?: boolean
}>`
  outline: none;
  border-radius: 16px;
  background: rgba(97, 105, 113, 0.08);
  color: ${({ theme }) => theme.navbarBtnColor};
  border: 2px solid ${({ theme }) => theme.navbarBtnBorder};
  &:hover,
  &:focus {
    border: 2px solid ${({ theme }) => darken(0.05, theme.deprecated_bg3)};
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.lg}px`}) {
    width: ${({ pending }) => !pending && '36px'};
    ${IconWrapper} {
      margin-right: 0;
    }
  }
`
export const AddressAndChevronContainer = styled.div`
  display: flex;
  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.navSearchInputVisible}px`}) {
    display: none;
  }
`
export const Text = styled.p`
  flex: 1 1 auto;
  margin: 0 0.5rem 0 0.25rem;
  color: #c2a676;
  overflow: hidden;
  white-space: nowrap;
  width: fit-content;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-overflow: ellipsis;
`
export const NetworkIcon = styled(AlertTriangle)`
  margin-left: 0.25rem;
  margin-right: 0.5rem;
  width: 16px;
  height: 16px;
`
export const StyledConnectButton = styled.button`
  background-color: transparent;
  border: none;
  border-top-left-radius: ${FULL_BORDER_RADIUS}px;
  border-bottom-left-radius: ${FULL_BORDER_RADIUS}px;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  padding: 10px 12px;
  color: inherit;
`
